// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../button/button.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._2FPu49alx{display:inline-flex}._5tjRHco3x{}._1m01A7Brx{}._1m01A7Brx,._1m01A7Brx:hover,._1m01A7Brx:active,._1m01A7Brx._2iiYiAdSx{box-shadow:none}._5FhqGVgtx{}._5FhqGVgtx:hover{box-shadow:inset 0 -2px 20px 0 rgba(0,0,0,0.1)}._5FhqGVgtx:active,._5FhqGVgtx._2iiYiAdSx{box-shadow:inset 0 -2px 20px 0 rgba(0,0,0,0.3)}._2iiYiAdSx{}._4nQuEiKAx{position:relative;display:inline-flex}._1v04PrvKx{}._2Q7vQeCtx{}._11paJeZAx{}._39vut7Qfx{}._5pKOIGyZx{border-top-right-radius:0;border-bottom-right-radius:0}._5mWLKmEIx,._5IoP2Rgux{position:static}._5mWLKmEIx{border-top-left-radius:0;border-bottom-left-radius:0;margin-left:-1px;border-left:1px solid rgba(0,0,0,0.1);padding-left:5px;padding-right:5px}._5mWLKmEIx._1v04PrvKx{min-width:0;padding-left:0;padding-right:0}._5mWLKmEIx._2Q7vQeCtx{min-width:0;padding-left:3px;padding-right:3px}._5mWLKmEIx._11paJeZAx{min-width:0;padding-left:5px;padding-right:5px}._5mWLKmEIx._39vut7Qfx{min-width:0;padding-left:6px;padding-right:6px}._4g5COXp9x{width:auto;box-shadow:0 6px 12px rgba(0,0,0,0.12)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"menu": "_2FPu49alx",
	"button": "_5tjRHco3x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["button"] + "",
	"button-like": "_1m01A7Brx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["button-like"] + "",
	"buttonLike": "_1m01A7Brx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["button-like"] + "",
	"active": "_2iiYiAdSx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["active"] + "",
	"colorful-button": "_5FhqGVgtx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["colorful-button"] + "",
	"colorfulButton": "_5FhqGVgtx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["colorful-button"] + "",
	"split-menu": "_4nQuEiKAx",
	"splitMenu": "_4nQuEiKAx",
	"xsmall": "_1v04PrvKx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["xsmall"] + "",
	"small": "_2Q7vQeCtx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["small"] + "",
	"normal": "_11paJeZAx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["normal"] + "",
	"large": "_39vut7Qfx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["large"] + "",
	"primary-action": "_5pKOIGyZx",
	"primaryAction": "_5pKOIGyZx",
	"secondary-action": "_5mWLKmEIx",
	"secondaryAction": "_5mWLKmEIx",
	"dropdown": "_5IoP2Rgux",
	"list": "_4g5COXp9x"
};
module.exports = exports;
